<template>
  <div class="no-offers">
    <div class="row">
      <div class="col-sm-8">
        <div v-if="hasContentInfos">
          <div class="col-12" >
            <h4 v-html="NoOffersTitle"></h4>
          </div>
          <div class="col-12" v-html="NoOffersText"></div>
        </div>
        <div v-else>
          <h4>No Offers Found</h4>
          Sorry, but at this time there are no offers available.
        </div>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'NotValid',
  props: ['consumerId'],
  computed: {
    hasContentInfos () {
      return this.contentTextInfos.length > 0
    },
    NoOffersTitle () {
      return this.mapText(this.contentTextInfos[0].no_offer_page_title)
    },
    NoOffersText () {
      return this.mapText(this.contentTextInfos[0].no_offer_page_body)
    },
    ...mapState({
      loadedId: state => state.consumer.consumerId,
      contentTextInfos: state => state.consumer.contentTextInfos
    }),
    ...mapGetters({
      consumerLoaded: 'consumer/consumerLoaded',
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  methods: {
    load (id) {
      if (!this.consumerLoaded || this.loadedId !== id) {
        this.loadConsumer(id)
      }
    },
    mapText (text) {
      const leadFields = [['__consumer_phone__', 'phone1'],
        ['__consumer_name__', 'fullname'],
        ['__consumer_email__', 'email'],
        ['__consumer_firstname__', 'firstname'],
        ['__consumer_lastname__', 'lastname'],
        ['__agent_id__', 'agent_id'],
        ['__agent_name__', 'agent_name'],
        ['__call_center_dba__', 'call_center_dba'],
        ['__consumer_address__', 'address'],
        ['__consumer_city__', 'city'],
        ['__consumer_state__', 'state'],
        ['__consumer_zip__', 'zip']]

      if (this.leadInfo) {
        leadFields.forEach((item) => {
          text = text.replace(new RegExp(item[0], 'g'), this.leadInfo[item[1]] ?? '')
        })
      }
      return text
    },
    ...mapActions({
      loadConsumer: 'consumer/retrieveConsumer'
    })
  },
  mounted () {
    if (this.consumerId) {
      this.load(this.consumerId)
    }
  },
  watch: {
    consumerId (val) {
      this.load(val)
    }
  }
}
</script>
